import axios from "axios";

export default axios.create({
    baseURL: "https://api-ieaqui.avamobile.com.br/company/"
    //baseURL: "http://192.168.0.2:3001/company/"
});
